import Modes from "./components/Modes";

export default Modes